// extracted by mini-css-extract-plugin
export default {"container":"CashDescription_container__4sf2j","total-cash-title":"CashDescription_total-cash-title__GUkfh","hide":"CashDescription_hide__pGerP"};